import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

const Register = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      toast.error('Wagwoorde stem nie ooreen nie');
      return;
    }

    if (password.length < 6) {
      toast.error('Wagwoord moet ten minste 6 karakters wees');
      return;
    }

    setLoading(true);

    try {
      await register(name, email, password);
      toast.success('Rekening suksesvol geskep');
      navigate('/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Registrasie het misluk');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen py-24 md:py-32 px-6 md:px-12 flex items-center justify-center">
      <div className="w-full max-w-md">
        <h1 className="font-heading text-4xl md:text-5xl font-normal tracking-tight text-charcoal mb-8 text-center">
          Registreer
        </h1>

        <div className="bg-parchment border border-[#E5E0D6] p-8 md:p-12">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block font-ui text-sm uppercase tracking-widest text-charcoal mb-2">
                Naam
              </label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                data-testid="register-name"
                className="w-full bg-transparent border-b border-charcoal/20 focus:border-gold px-0 py-4 text-xl font-body placeholder:text-charcoal/40 outline-none transition-colors"
                placeholder="U volledige naam"
              />
            </div>

            <div>
              <label className="block font-ui text-sm uppercase tracking-widest text-charcoal mb-2">
                E-pos
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="register-email"
                className="w-full bg-transparent border-b border-charcoal/20 focus:border-gold px-0 py-4 text-xl font-body placeholder:text-charcoal/40 outline-none transition-colors"
                placeholder="u.epos@voorbeeld.com"
              />
            </div>

            <div>
              <label className="block font-ui text-sm uppercase tracking-widest text-charcoal mb-2">
                Wagwoord
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="register-password"
                className="w-full bg-transparent border-b border-charcoal/20 focus:border-gold px-0 py-4 text-xl font-body placeholder:text-charcoal/40 outline-none transition-colors"
                placeholder="••••••••"
              />
            </div>

            <div>
              <label className="block font-ui text-sm uppercase tracking-widest text-charcoal mb-2">
                Bevestig Wagwoord
              </label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                data-testid="register-confirm-password"
                className="w-full bg-transparent border-b border-charcoal/20 focus:border-gold px-0 py-4 text-xl font-body placeholder:text-charcoal/40 outline-none transition-colors"
                placeholder="••••••••"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              data-testid="register-submit"
              className="w-full bg-charcoal text-parchment hover:bg-charcoal/80 rounded-sm px-8 py-4 font-ui uppercase tracking-widest text-sm transition-colors duration-300 disabled:opacity-50"
            >
              {loading ? 'Besig...' : 'Registreer'}
            </button>
          </form>

          <div className="mt-8 text-center">
            <p className="font-body text-lg text-muted-charcoal">
              Het u reeds 'n rekening?{' '}
              <Link to="/login" data-testid="link-to-login" className="text-gold hover:underline">
                Teken aan
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
